<template>
    <div class="container">
      <div class="succ">
        <img src="../../assets/images/act_success.png" alt=""/>
        <span>{{'预定成功'}}</span>
      </div>
      <p v-if="payType==1" class="desc" >请尽快完成线下支付</p>
      <p  v-else class="desc" >您已成功预定会议室</p>
    
      <!-- <p class="sqText" @click="goToGetConfirm">授权会议开始提醒</p> -->
      <div class="button">
           <mt-button :class="['btn_primary', $store.state.common.theme==3?'btn_primary_3':'']" v-on:click="toDetail" >查看详情</mt-button>
           <mt-button :class="['btn_default',$store.state.common.theme==3?'btn_default_3':'']" v-on:click="toOrderList">查看订单</mt-button>
      </div>

      <template v-if="templateIds" >
        <!-- @click="goToGetConfirm" -->
        <!-- <p class="sqText" >授权活动提醒</p> -->
        <div class="subscribeBox" >
          <wx-open-subscribe :template="templateIds"  id="subscribe-btn">
            <script type="text/wxtag-template" slot="style">
                <style>
                    .subscribe-btn {
                        margin-left: 16px;
                        padding-left: 10px;
                        padding-right: 10px;
                        line-height: 34px;
                        flex-direction: row;
                    }
                    .subscribe-img{
                      margin-top: 0px;
    
                      height: 25px;
                      width: 25px;
                    }
                    .subscribe-text{
                      color:#1296db;
                      font-size: 18px;
                      padding-right: 3px;
                    }
                    .subscribe-text1{
                      font-size: 18px;
                      color:#999999;
                    }
                </style>
            </script>
            <script type="text/wxtag-template">
                <div class="subscribe-btn" style="display:flex;align-items:center;justify-content:center;">
                  <img class='subscribe-img' src="data:image/png;base64,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"/>
                  <span class='subscribe-text'>点击此处</span>
                  <span class='subscribe-text1'>订阅会议室通知</span>
                  
                </div>
            </script>
          </wx-open-subscribe>
        </div>
      </template>
  
    </div>
  </template>
  
  <script>
  import { serversRootUrl } from '../../utils/api'
  import { getShareInfo,getWxTemplates } from "../../utils/api";
  import { mapState } from 'vuex';
  import wx from 'weixin-js-sdk'
  export default {
    name: 'RoomSuccess',
    data () {
      return {
        payType:'',
        isVerify:0,
        ShareInfo:"",
        appid:'',
        templateId:'',
        templateIds:"",
      }
    },
    created () {
      this.payType = this.$route.query.payType
      this.getWxTemplatesAction()
    },
    activated () {
        this.getShareInfo();


    },
    methods: {

      getWxTemplatesAction(){
        let params = {
          orderType:1   //会议室
        }
        getWxTemplates(params).then(res=>{
          if(res.res.code === 10000){
            var list = res.body.wxMsgTemplateList
            var list1 =[]
            for(var i=0;i<list.length;i++){
              list1.push(list[i].templateId)
            }
            this.templateIds = list1.join(',')

            console.log('this.templateId ===  ' + this.templateIds)
          }
        })
      },

    getShareInfo(){
      var url =  window.location.href.split('#')[0]
        let params = {
          url:url
        }
        if(this.$route.query.cityId){
          params.cityId = this.$route.query.cityId
        }else if(this.common.cityId)  {
          params.cityId = this.common.cityId
        }else{
          params.marketId = this.common.marketInfo.id || ''
        }
        console.log('in getShareInfo   '+ JSON.stringify(params) );
        var that = this;
        getShareInfo(params).then(res=>{
          if(res.res.code === 10000){
            this.ShareInfo =res.body;
            wx.config({
                  debug: false,
                  appId: this.ShareInfo.appid, // 必填，公众号的唯一标识
                  timestamp: this.ShareInfo.timestamp, // 必填，生成签名的时间戳，精确到秒
                  nonceStr: this.ShareInfo.nonceStr, // 必填，生成签名的随机串
                  signature: this.ShareInfo.signature, // 必填，签名
                  jsApiList: ['onMenuShareAppMessage'],
                  openTagList: ['wx-open-subscribe']
            })
            wx.error(function(res){
                  // util.showToast("错误信息== error   " + res.errMsg,6000);
                // 暂时解决不了 比较慢的iOS手机微信版本 获取的URL问题 所以config失败 使用当前url 再config 一次
                console.log('in error  '+ JSON.stringify(res) );
                var errMsg =  res.errMsg
                 if(errMsg.indexOf('config') > -1 ){
                  that.errorBackconfig();
                 }
            });

            wx.ready(()=>{
                console.log("in wx.ready")
            })
           
          }
        })
   },

    //config 失败后用当前url重新config
    errorBackconfig(){
       var url =  window.location.href.split('#')[0]
       let params = {
          url:url
        }
        if(this.$route.query.cityId){
          params.cityId = this.$route.query.cityId
        }else if(this.common.cityId)  {
          params.cityId = this.common.cityId
        }else{
          params.marketId = this.common.marketInfo.id || ''
        }
        console.log('in errorBackconfig   '+ JSON.stringify(params) );
    
        getShareInfo(params).then(res=>{
          var configMap={
              debug: false,
              appId: res.body.appid , // 必填，公众号的唯一标识
              timestamp:res.body.timestamp  , // 必填，生成签名的时间戳，精确到秒
              nonceStr: res.body.nonceStr, // 必填，生成签名的随机串
              signature: res.body.signature, // 必填，签名
              jsApiList: ['onMenuShareAppMessage'],
              openTagList: ['wx-open-subscribe']
           }
            wx.config(configMap)
            wx.error(function(res){
                  // util.showToast("错误信息== error   " + res.errMsg,6000);
                  console.log('in error  '+ JSON.stringify(res) );
            });
            wx.ready(()=>{
              console.log("in errorBackconfig wx.ready")
            })
        })

    },
      toIndex () {
        this.$router.push('/meetingRoom')
      },
      toOrderList () {
        this.$router.push('/myOrder?come=meeting')
      },
      goToGetConfirm(){
         var url='https://mp.weixin.qq.com/mp/subscribemsg?action=get_confirm&appid=' 
         var appid =   'wx4991c2b9ad32827e'  // this.appid
         var templateId ='snE2Vq9qZapLVsp9aravBAIGVwEY2uaVXgaYjZXH1to'    //this.templateId
         var scene=20
        // 'https://rsttest.vanke.com'
         var redirectUrl =serversRootUrl//+ 'activitySuccess?isVerify='+this.activityDetails.isVerify+'&marketId='+this.activityDetails.marketId
         redirectUrl =encodeURIComponent(redirectUrl)
         var reserved = this.common.marketInfo.id
      
         url =url+appid +'&scene='+scene +'&template_id='+templateId+'&redirect_url='+redirectUrl + '&reserved='+reserved+'#wechat_redirect'
         console.log('url ' +url)
  
         window.location.href = url
  
      },
    },
    computed: {
      ...mapState({
        userId: state => state.common.userId,
        common: state => state.common
      })
    },
  }
  </script>
  <style lang='less' scoped>
  @import "../../assets/css/common.less";
  body {
    min-height: 100vh;
    background: #fff;
  }
  .container {
      background: #fff;
  }
  .succ{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 120px;
    margin-bottom: 28px;
    height:66px;
    img{
      display: block;
      width:44px;
      height:44px;
      margin-right:14px;
    }
    span{
      height:66px;
      font-size:48px;
      font-weight:bold;
      color:rgba(51,51,51,1);
      line-height:66px;
    }
  }
  .succesTitle{
      display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 28px;
    span{
      display: block;
      .fontSize(18px);
      font-weight: bold;
      color:@color3;
    }
  
  }
  
  .desc{
    width:100%;
    height:40px;
    .fontSize(14px);
    color:@color9;
    line-height:40px;
    margin-bottom: 80px;
    text-align: center;
  }
  .sqText{
    .fontSize(14px);
    color:#F58D07 ;
    margin-left: 32px;
    margin-bottom: 20px;
  }
  .subscribeBox{
    margin-top: 40px;
    width: 750px;
    height: 100px;
    display: flex;
  }
  
  
  .button{
    display: flex;
    position: fixed;
    width: 750px;
    bottom: 10px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
      .btn_primary{
      margin-left: 32px;
      width:332px;
      height:68px;
      background:#fff;
      .border(#96AAF0);
      border-radius:4px;
      .fontSize(14px);
      color:@color17;
      line-height:68px;
      display: block;
      background:rgba(243,245,253,1);
      }
      .btn_primary_3{
        .border(#A1805D);
        color:#A1805D;
      }
  
      .btn_default{
        margin-right: 32px;
        width:332px;
        height:68px;
        background:@color17;
        .border(@color17);
        border-radius:4px;
        .fontSize(14px);
        color:#fff;
        line-height:68px;
        display: block;
      }
      .btn_default_3{
        background:#A1805D;
        .border(#A1805D);
      }
  }
  
  
  </style>